import styled from 'styled-components';

export default styled.div`
  button.schedule-appt-button, button.add-button {
    width: 100%;
    font-size: 18px;
    padding: 14px;
    margin-bottom: 0.5em;
  };
  .apply-now-link{
    color: #3e7697;
    display: inline;
    font-size: 14px;
  }
  .schedule-appt-hyperlink {
    display: block;
    font-size: 14px;
    line-height: 16px;
    margin-top: 6px;
    span {
      display: inline;
      vertical-align: top;
      color: #333;
      @media screen and (max-width: 767px) {
        display: none;
      }
    }
    button {
      display: inline;
      vertical-align: top;
      border: none;
      outline: none;
      background: transparent;
      color: #3E7697;
      cursor: pointer;
      padding: 0;
    }
  };
`;
